/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Grounding_BodyInputs */

const en_us2_plan_build_grounding_body = /** @type {(inputs: Plan_Build_Grounding_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each one changes what the trainer suggests: volume, exercises and rest. It takes less than a minute.`)
};

const pt_br2_plan_build_grounding_body = /** @type {(inputs: Plan_Build_Grounding_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada uma muda o que ele sugere: volume, exercícios e descanso. Leva menos de um minuto.`)
};

const es_419_plan_build_grounding_body = /** @type {(inputs: Plan_Build_Grounding_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada una cambia lo que el entrenador sugiere: volumen, ejercicios y descanso. Toma menos de un minuto.`)
};

const pt_pt2_plan_build_grounding_body = /** @type {(inputs: Plan_Build_Grounding_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada uma muda o que ele sugere: volume, exercícios e descanso. Demora menos de um minuto.`)
};

const fr_fr2_plan_build_grounding_body = /** @type {(inputs: Plan_Build_Grounding_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chacune change ce que le coach suggère : volume, exercices et repos. Ça prend moins d'une minute.`)
};

const de_de2_plan_build_grounding_body = /** @type {(inputs: Plan_Build_Grounding_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede ändert, was dein Coach vorschlägt: Volumen, Übungen und Pausen. Dauert keine Minute.`)
};

const it_it2_plan_build_grounding_body = /** @type {(inputs: Plan_Build_Grounding_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ognuna cambia quello che il coach suggerisce: volume, esercizi e recupero. Ci vuole meno di un minuto.`)
};

/**
* | output |
* | --- |
* | "Each one changes what the trainer suggests: volume, exercises and rest. It takes less than a minute." |
*
* @param {Plan_Build_Grounding_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_grounding_body = /** @type {((inputs?: Plan_Build_Grounding_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Grounding_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_grounding_body(inputs)
	if (locale === "es-419") return es_419_plan_build_grounding_body(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_grounding_body(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_grounding_body(inputs)
	if (locale === "de-DE") return de_de2_plan_build_grounding_body(inputs)
	if (locale === "it-IT") return it_it2_plan_build_grounding_body(inputs)
	return en_us2_plan_build_grounding_body(inputs)
});
export { plan_build_grounding_body as "plan-build.grounding_body" }